import * as React from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link } from 'react-router-dom'
import baseUrlApi from '../../lib/baseUrlApi';
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';
import {useCookies} from "react-cookie";
import Rule from "../../Consts/Rules";

type SiteAdminInputs = {
    siteId: string;
    admin: string;
    user: string;
    memo: string;
};

interface SiteAdminProps {
    setState: Function;
}

export default function BasicModal(props: SiteAdminProps) {
    const [open, setOpen] = React.useState(false);
    const [siteId, setSiteId] = useState<string>("");
    const [admin, setAdmin] = useState<string>("adminsgw");
    const [user, setUser] = useState<string>("user1234");
    const [memo, setMemo] = useState<string>("");
    const [SiteData, setSiteData] = useState<SiteAdminInputs[]>([]);
    const { register, reset, handleSubmit, formState: { errors } } = useForm<SiteAdminInputs>({
        defaultValues: {
            siteId: "",
            admin: "adminsgw",
            user: "user1234",
        }
      });
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const [error, setError] = useState<[]>([]);
    const rules = {
        required: '入力してください。',
        maxLength: {
            value: 255,
            message: "255文字以内で入力してください"
        },
        pattern: {
            value: /^[a-zA-Z0-9!@#$%^&*()_+,\.\-';:"<>?/\[\]{}|`~]+$/,
            message: "英数字のみ入力可能です"
        }
    }
    const resetData = async() => {
        setSiteId("");
        setAdmin("adminsgw");
        setUser("user1234");
        setMemo("");
        setSiteData([]);
        setError([]);
        reset();
    }
    const handleOpen = async() => {
        resetData();
        setOpen(true);
    }
    const handleClose = async() => {
        resetData();
        setOpen(false);
    }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit: SubmitHandler<SiteAdminInputs> = async (data) => {
        try {
            const token = cookies.access_token || "";
            let params = {
                "siteId": siteId,
                "prcKind": 0,
                "sitePass": {
                    "admin": admin,
                    "user": user
                },
                "memo" : memo
            };
            await ApiRequest.registSiteManage(params, token, (response: any) => {
                if (Array.isArray(response.data)) {
                    setSiteData(response.data);
                }
                setError(response.data.messsages);
                if (response.data.result === 0) {
                    handleClose();
                }
                props.setState(" ");
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            handleClose();
        }
    };

    return (
        <div>
            <button onClick={handleOpen} className="btn btn-blue"><i className="icon-add-w"></i>現場追加</button>
            <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: 'flex' }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                新規現場追加
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error && error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">現場ID<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input
                                            type="text"
                                            defaultValue={siteId}
                                            placeholder="siteId"
                                            //WARNING:バリデーションルールが適用されてません。
                                            {...register("siteId")}
                                            className={"col-320 " + (errors.siteId ? "error-disp" : "")}
                                            onChange={(e) => setSiteId(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">管理パスワード<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input
                                            type="text"
                                            defaultValue={admin}
                                            placeholder="admin"
                                            //WARNING:バリデーションルールが適用されてません。
                                            {...register("admin")}
                                            className={"col-320 " + (errors.admin ? "error-disp" : "")}
                                            onChange={(e) => setAdmin(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">閲覧パスワード<span className="required"></span></div>
                                    <div className="edit-box-elm-input">
                                        <input
                                            type="text"
                                            defaultValue={user}
                                            placeholder="user"
                                            //WARNING:バリデーションルールが適用されてません。
                                            {...register("user")}
                                            className={"col-320 " + (errors.user ? "error-disp" : "")}
                                            onChange={(e) => setUser(e.target.value)}
                                        />

                                    </div>
                                </div>
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">メモ</div>
                                    <div className="edit-box-elm-input">
                                        <textarea
                                            defaultValue={memo}
                                            placeholder="memo"
                                            //WARNING:バリデーションルールが適用されてません。
                                            {...register("memo")}
                                            className={"col-320 " + (errors.memo ? "error-disp" : "")}
                                            onChange={(e) => setMemo(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                                {/*<button className="btn btn-red-line">*/}
                                {/*    <i className="icon-delete-r"></i>削除*/}
                                {/*</button>*/}
                            </div>
                            <div className="model-action-main">
                                <button className="btn btn-blue-line">
                                    <a onClick={handleClose} className="">
                                        キャンセル
                                    </a>
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-blue col-160">
                                        <i className="icon-check-w"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
